<template>
    <div class="modal fade" :id="idModal" aria-hidden="true" tabindex="-1" :style="customModalMain">
        <div :class="[class_modal, size, fullscreen]" :style="customSizeWid">

            <div class="modal-content">

                <div class="modal-header" :class="ClassBG">
                    <slot name="header"></slot>

                    <button :style="hasToggleFull" class="btn-fullscren btn-white hover-effect" @click="toggleFullScreen">
                        <div v-if="!isFullscreen">
                            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M2.14286 9.64286H0V15H5.35714V12.8571H2.14286V9.64286ZM0 5.35714H2.14286V2.14286H5.35714V0H0V5.35714ZM12.8571 12.8571H9.64286V15H15V9.64286H12.8571V12.8571ZM9.64286 0V2.14286H12.8571V5.35714H15V0H9.64286Z"
                                    fill="#9F3029" />
                            </svg><span class="p-2">Expandir</span>
                        </div>
                        <div v-else>
                            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M0 11.7857H3.21429V15H5.35714V9.64286H0V11.7857ZM3.21429 3.21429H0V5.35714H5.35714V0H3.21429V3.21429ZM9.64286 15H11.7857V11.7857H15V9.64286H9.64286V15ZM11.7857 3.21429V0H9.64286V5.35714H15V3.21429H11.7857Z"
                                    fill="#9F3029" />
                            </svg><span class="p-2">Reduzir</span>
                        </div>
                    </button>

                </div>

                <div class="modal-body" :style="customModalBody">
                    <slot name="body"></slot>
                </div>

                <div class="modalF-default" :class="ClassFooter">
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'Modal',
        props: {
            hasToggleFull: {
                type: String,
                default: ''
            },
            idModal: {
                type: String,
                default: 'idModalDefault'
            },
            size: {
                type: String,
                default: ''
            },
            FooterDefault: {
                type: Boolean,
                default: true
            },
            headerBG: {
                type: Boolean,
                default: true
            },
            open: {
                type: Boolean,
                default: false
            },
            customSizeWid: {
                type: String,
                default: ''
            },
            customModalBody: {
                type: String,
                default: ''
            },
            customModalMain: {
                type: String,
                default: 'z-index:1055'
            },
            class_modal: {
                type: String,
                default: 'modal-dialog'
            }
        },
        data() {
            return {
                ClassFooter: '',
                ClassBG: '',
                fullscreen: '',
                isFullscreen: false,
            };
        },
        watch: {
            open(val) {
                if (!val) {
                    this.isFullscreen = false;
                }
            },
            isFullscreen(val) {
                if (val) {
                    this.fullscreen = 'fullscreen';
                } else {
                    this.fullscreen = '';
                }

                window.parent.postMessage({ type: 'fullscreen', fullscreen: val }, "*");
            }
        },
        methods: {
            toggleFullScreen() {
                this.isFullscreen = !this.isFullscreen;
            }
        },
        mounted() {
            if (this.FooterDefault) {
                this.ClassFooter = 'modal-footer';
            }

            if (this.headerBG) {
                this.ClassBG = 'class_header';
            }
        }
    }

</script>

<style scoped lang="scss">
    
    .btn-white {
        box-shadow: none !important;
    }

    .modal {
        background: rgba(255, 255, 255, 0.507);


        .modal-dialog {
            --bs-modal-width: 98%;
            margin: 8px 20px 8px 20px;
            border-radius: 0 !important;

            .btn-fullscren {
                position: absolute !important;
                right: 80px !important;
                top: 0px !important;
                border: none !important;
                background: transparent !important;
                padding-left: 15px !important;

                &.btn-white:hover {
                    background: white !important;
                    color: #9F3029 !important;
                    border: none !important;
                }
            }

            .class_header {
                z-index: 100;
                max-height: 20px;
                color: #9F3029;
                background-color: #FFFFFF;
                padding: 20px 25px;
                box-shadow: 0px 4px 10px 0px #00000040 !important;
            }

            .modal-body {
                min-height: calc(100vh - 7rem);
                max-height: calc(100vh - 7rem);
                overflow: auto;
                background: #f9f9f9;
            }

            &.fullscreen {
                position: absolute !important;
                top: 5px !important;
                right: 0px !important;
                bottom: 0px !important;
                left: 0px !important;
                margin: 0 !important;
                width: 100% !important;
                --bs-modal-width: 100% !important;


                .class_header {
                    z-index: 100;
                    max-height: 20px !important;
                    color: #9F3029;
                    background-color: #FFFFFF;
                    padding: 20px 25px;
                    box-shadow: 0px 4px 10px 0px #00000040 !important;
                    border-radius: 0 !important;
                    top: -5px;
                    position: relative;
                }

                .modal-body {
                    min-height: calc(100vh - 98px) !important;
                    padding-left: 20px;
                    padding-right: 20px;
                    padding-top: 10px;
                    overflow: auto;
                    max-height: calc(100vh - 110px);
                }
            }
        }
    }

    #ModalTicket {
        .modal-body {
            overflow: hidden;
        }
    }
</style>